export const TEAM_MEMBERS = [
  {
    id: 'IBM1',
    name: 'IBM1',
    role: 'Quantum Researcher IBM',
    category: 'IBM Team',
    image: '/People/Placeholder.jpg',
    linkedin: 'https://www.linkedin.com/',
    campus: 'UMD'
  },
  {
    id: 'IBM2',
    name: 'IBM2',
    role: 'Quantum Researcher IBM',
    category: 'IBM Team',
    image: '/People/Placeholder.jpg',
    linkedin: 'https://www.linkedin.com/',
    campus: 'UMD'
  },
  {
    id: 'IBM3',
    name: 'IBM3',
    role: 'Quantum Researcher IBM',
    category: 'IBM Team',
    image: '/People/Placeholder.jpg',
    linkedin: 'https://www.linkedin.com/',
    campus: 'USC'
  },
  {
    id: 'IBM4',
    name: 'IBM4',
    role: 'Quantum Researcher IBM',
    category: 'IBM Team',
    image: '/People/Placeholder.jpg',
    linkedin: 'https://www.linkedin.com/',
    campus: 'USC'
  },
  {
    id: 'Rosa Di Felice',
    name: 'Rosa Di Felice',
    role: 'USC Faculty',
    category: 'Advisors',
    image: '/People/rosa.avif',
    linkedin: 'https://www.linkedin.com/',
    campus: 'UMD'
  },
  {
    id: 'Federico Spedalieri',
    name: 'Federico Spedalieri',
    role: 'USC Faculty',
    category: 'Advisors',
    image: '/People/Fedrico Spedali.jpg',
    linkedin: 'https://www.linkedin.com/in/federico-spedalieri-06b9ba5/',
    campus: 'UMD'
  },
  {
    id: 'Eli Levenson-Falk',
    name: 'Eli Levenson-Falk',
    role: 'USC Faculty',
    category: 'Advisors',
    image: '/People/Placeholder.jpg',
    linkedin: 'https://www.linkedin.com/',
    campus: 'USC'
  },
  {
    id: 'Kevin Giang, Ed. D',
    name: 'Kevin Giang, Ed. D',
    role: 'USC Faculty',
    category: 'Advisors',
    image: '/People/Kevin_Giang_headshot.jpeg',
    linkedin: 'https://www.linkedin.com/',
    campus: 'USC'
  },
  {
    id: 'Sadman Ahmed Shanto',
    name: 'Sadman Ahmed Shanto',
    role: 'Judge-USC',
    category: 'Advisors',
    image: '/People/Sadman Ahmed Shanto.jpeg',
    linkedin: 'https://www.linkedin.com/in/sshanto/',
    campus: 'UMD'
  },
  {
    id: 'Naman Jain',
    name: 'Naman Jain',
    role: 'Judge-USC',
    category: 'Advisors',
    image: '/People/Naman Jain.jpg',
    linkedin: 'https://www.linkedin.com/in/naman-jain-01/',
    campus: 'UMD'
  },
  {
    id: 'Devika Mehra',
    name: 'Devika Mehra',
    role: 'Judge-QEE',
    category: 'Advisors',
    image: '/People/Devika Mehra.jpg',
    linkedin: 'https://www.linkedin.com/in/devika-mehra-25469494',
    campus: 'USC'
  },
  {
    id: 'Brennen G. Rudd',
    name: 'Brennen G. Rudd',
    role: 'Judge-QEE',
    category: 'Advisors',
    image: '/People/Brenne G. Rudd.jpg',
    linkedin: 'https://www.linkedin.com/in/brennen-glenn-rudd-b33308261/',
    campus: 'USC'
  },
  {
    id: 'Tina Tran',
    name: 'Tina Tran',
    role: 'UMD QEE Marketing Lead',
    category: 'Organizing Team',
    image: '/People/Placeholder.jpg',
    linkedin: 'https://www.linkedin.com/in/tina-tran-7a9976156/',
    campus: 'UMD'
  },
  {
    id: 'Jacklyn Nguyen',
    name: 'Jacklyn Nguyen',
    role: 'UMD QEE Marketing Lead',
    category: 'Organizing Team',
    image: '/People/Placeholder.jpg',
    linkedin: 'https://www.linkedin.com/',
    campus: 'UMD'
  },
  {
    id: 'Jamie Le',
    name: 'Jamie Le',
    role: 'UMD QEE Logistics Lead',
    category: 'Organizing Team',
    image: '/People/Placeholder.jpg',
    linkedin: 'https://www.linkedin.com/',
    campus: 'UMD'
  },
  {
    id: 'Atuh Fon',
    name: 'Atuh Fon',
    role: 'UMD QEE Logistics & Web Developer',
    category: 'Organizing Team',
    image: '/People/Placeholder.jpg',
    linkedin: 'https://www.linkedin.com/',
    campus: 'UMD'
  },
  {
    id: 'Pranavsai Akurati',
    name: 'Pranavsai Akurati',
    role: 'UMD QEE Logistics & Web Developer',
    category: 'Organizing Team',
    image: '/People/Placeholder.jpg',
    linkedin: 'https://www.linkedin.com/',
    campus: 'UMD'
  },
  {
    id: 'Ishara Shanmugasundaram',
    name: 'Ishara Shanmugasundaram',
    role: 'UMD QEE Web Development Lead',
    category: 'Organizing Team',
    image: '/People/Placeholder.jpg',
    linkedin: 'https://www.linkedin.com/',
    campus: 'UMD'
  },
  {
    id: 'Yazmin Zare',
    name: 'Yazmin Zare',
    role: 'UMD QEE Web Developer',
    category: 'Organizing Team',
    image: '/People/Placeholder.jpg',
    linkedin: 'https://www.linkedin.com/',
    campus: 'UMD'
  },
  {
    id: 'Sophia Jin',
    name: 'Sophia Jin',
    role: 'UMD QEE Web Developer',
    category: 'Organizing Team',
    image: '/People/Placeholder.jpg',
    linkedin: 'https://www.linkedin.com/',
    campus: 'UMD'
  },
  {
    id: 'Anoushka Aurora',
    name: 'Anoushka Aurora',
    role: 'UMD QEE Web Developer',
    category: 'Organizing Team',
    image: '/People/Placeholder.jpg',
    linkedin: 'https://www.linkedin.com/',
    campus: 'UMD'
  },
  {
    id: 'Aiden Fox',
    name: 'Aiden Fox',
    role: 'USC QEE Treasurer',
    category: 'Organizing Team',
    image: '/People/Aiden Fox.png',
    linkedin: 'https://www.linkedin.com/',
    campus: 'USC'
  },
  {
    id: 'Nehir Keskin',
    name: 'Nehir Keskin',
    role: 'USC QEE Tech and Industry Relations Lead',
    category: 'Organizing Team',
    image: '/People/Nehir Keskin.jpeg',
    linkedin: 'https://www.linkedin.com/',
    campus: 'USC'
  },
  {
    id: 'Giovanni Suarez',
    name: 'Giovanni Suarez',
    role: 'USC QEE Vice President',
    category: 'Organizing Team',
    image: '/People/Giovanni Suarez.jpg',
    linkedin: 'https://www.linkedin.com/',
    campus: 'USC'
  },
  {
    id: 'Rose Sifuentes',
    name: 'Rose Sifuentes',
    role: 'USC QEE Secretary',
    category: 'Organizing Team',
    image: '/People/Rose Sifuentes .JPG',
    linkedin: 'https://www.linkedin.com/',
    campus: 'USC'
  },
  {
    id: 'Peter Connolly',
    name: 'Peter Connolly',
    role: 'USC QEE Programming Chair',
    category: 'Organizing Team',
    image: '/People/Peter Mai Connolly .jpg',
    linkedin: 'https://www.linkedin.com/',
    campus: 'USC'
  },
  {
    id: 'Ayush Rajpal',
    name: 'Ayush Rajpal',
    role: 'USC QEE Web Developer',
    category: 'Organizing Team',
    image: '/People/Ayush Rajpal.jpg',
    linkedin: 'https://www.linkedin.com/',
    campus: 'USC'
  },
  {
    id: 'Noor Zooby',
    name: 'Noor Zooby',
    role: 'USC QEE Marketing Co-Lead',
    category: 'Organizing Team',
    image: '/People/Noor Zooby.jpeg',
    linkedin: 'https://www.linkedin.com/',
    campus: 'USC'
  },
  {
    id: 'Naimeh Dughbaj',
    name: 'Naimeh Dughbaj',
    role: 'USC QEE Marketing Co-Lead',
    category: 'Organizing Team',
    image: '/People/Naimeh Dughbaj.jpg',
    linkedin: 'https://www.linkedin.com/in/naimeh-dughbaj-72a6562b6/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
    campus: 'USC'
  },
  {
    id: 'Laila Matin',
    name: 'Laila Matin',
    role: 'USC QEE Marketing Team Member',
    category: 'Organizing Team',
    image: '/People/Placeholder.jpg',
    linkedin: 'https://www.linkedin.com/',
    campus: 'USC'
  },
  {
    id: 'Tina Habibi',
    name: 'Tina Habibi',
    role: 'USC QEE Education Lead',
    category: 'Organizing Team',
    image: '/People/Tina Habibi.jpeg',
    linkedin: 'https://www.linkedin.com/in/tina-habibi?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app',
    campus: 'USC'
  },
  {
    id: 'Ryan Nene',
    name: 'Ryan Nene',
    role: 'USC QEE ',
    category: 'Organizing Team',
    image: '/People/Ryan Nene.jpg',
    linkedin: 'https://www.linkedin.com/in/ryan-nene-7164b0291/',
    campus: 'USC'
  },
  {
    id: 'Richa Misra',
    name: 'Richa Misra',
    role: 'USC QEE ',
    category: 'Organizing Team',
    image: '/People/Placeholder.jpg',
    linkedin: 'https://www.linkedin.com/in/richa-misra-m/',
    campus: 'USC'
  },
  {
    id: 'Rida Faraz',
    name: 'Rida Faraz',
    role: 'USC QEE ',
    category: 'Organizing Team',
    image: '/People/Rida Faraz.jpg',
    linkedin: 'https://www.linkedin.com/in/rida-faraz/',
    campus: 'UMD'
  },
  {
    id: 'Hamin Jin',
    name: 'Hamin Jin',
    role: 'USC QEE ',
    category: 'Organizing Team',
    image: '/People/Hamin Jin.jpg',
    linkedin: 'https://www.linkedin.com/in/hamin-jin',
    campus: 'UMD'
  },
  {
    id: 'Kate Pundyk',
    name: 'Kate Pundyk',
    role: 'USC QEE ',
    category: 'Organizing Team',
    image: '/People/Kate Pundyk.png',
    linkedin: 'https://www.linkedin.com/in/kate-pundyk/',
    campus: 'UMD'
  },
  {
    id: 'Arman Babakhani',
    name: 'Arman Babakhani',
    role: 'USC QEE ',
    category: 'Organizing Team',
    image: '/People/Arman.png',
    linkedin: 'https://www.linkedin.com/in/arman-babakhani/',
    campus: 'UMD'
  },
  {
    id: 'Abhinav Vadhera',
    name: 'Abhinav Vadhera',
    role: 'USC QEE Voting Member',
    category: 'Organizing Team',
    image: '/People/Abhinav Vadhera.png',
    linkedin: 'https://www.linkedin.com/',
    campus: 'UMD'
  },
  {
    id: 'Victor Adeyemi',
    name: 'Victor Adeyemi',
    role: 'Qiskit Advocate',
    category: 'IBM Qiskit Advocate Mentors',
    image: '/People/Victor Adeyemi.jpg',
    linkedin: 'https://www.linkedin.com/in/victor-adeyemi-37b9167b/',
    campus: 'UMD'
  },
  {
    id: 'Hassan Alhusayni',
    name: 'Hassan Alhusayni',
    role: 'Qiskit Advocate',
    category: 'IBM Qiskit Advocate Mentors',
    image: '/People/Hassan Alhusayni.jpeg',
    linkedin: 'https://www.linkedin.com/in/hassan-alhusayni/',
    campus: 'UMD'
  },
  {
    id: 'Rishikesh Gokhale',
    name: 'Rishikesh Gokhale',
    role: 'Qiskit Advocate',
    category: 'IBM Qiskit Advocate Mentors',
    image: '/People/Placeholder.jpg',
    linkedin: 'https://www.linkedin.com/in/hassan-alhusayni/',
    campus: 'USC'
  },
  {
    id: 'Mark Agib ',
    name: 'Mark Agib ',
    role: 'Qiskit Advocate',
    category: 'IBM Qiskit Advocate Mentors',
    image: '/People/Placeholder.jpg',
    linkedin: 'https://www.linkedin.com',
    campus: 'USC'
  }
];
